
import { defineComponent, onBeforeMount, toRefs, watch } from 'vue'

import { useProduct } from '../../composables/useProduct'

import PProductInfo from './presenters/PProductInfo.vue'

export default defineComponent({
  name: 'CProduct',
  components: {
    PProductInfo,
  },
  props: {
    sku: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const { sku } = toRefs(props)

    const { product, loadProduct } = useProduct(sku)

    onBeforeMount(loadProduct)
    watch(sku, loadProduct)

    return { product }
  },
})
